import React from 'react'

// Bootstrap
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';

export default class ContactForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            subject: '',
            message: ''
        };

        this.handleChangeSubject = this.handleChangeSubject.bind(this);
        this.handleChangeMessage = this.handleChangeMessage.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }
  
    // Handle text input events
    handleChangeSubject(event) {
        this.setState({subject: event.target.value});
    }

    handleChangeMessage(event) {
        this.setState({message: event.target.value});
    }

    // Handle Submit
    handleSubmit(event) {
        window.location.href = "mailto:" + this.props.mailto + "?subject=" + this.state.subject + "&body=" + this.state.message;
        event.preventDefault();
    }
  
    render() {
      return (
        <Form className="contact-form" onSubmit={this.handleSubmit}>
          <Form.Group>
            <Form.Label>Subject:</Form.Label>
            <Form.Control type="text" placeholder="Enter subject" value={this.state.subject} onChange={this.handleChangeSubject} />
          </Form.Group>
          <Form.Group>
            <Form.Label>Message:</Form.Label>
            <Form.Control className="contact-form-message" type="text" as="textarea" placeholder="Enter message" value={this.state.message} onChange={this.handleChangeMessage} />
          </Form.Group>
          <Button type="submit" variant="secondary">Submit</Button>
        </Form>
      );
    }
  }